"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _NavBar = require("../NavBar/NavBar");
require("./MobileNav.scss");
var _logoIcon = _interopRequireDefault(require("../../images/logo-icon.svg"));
var _user = _interopRequireDefault(require("../../images/user.svg"));
var _downCaretDarkBlue = _interopRequireDefault(require("../../images/down-caret-dark-blue.svg"));
var _useNavigator = _interopRequireDefault(require("../../utils/hooks/useNavigator"));
var _MobileMegaMenu = _interopRequireDefault(require("../MobileMegaMenu/MobileMegaMenu"));
var _MobileMenu = _interopRequireDefault(require("../MobileMenu/MobileMenu"));
var _MobileDashboardMenu = _interopRequireDefault(require("../MobileDashboardMenu/MobileDashboardMenu"));
var _MyCartMenu = _interopRequireDefault(require("./MyCartMenu"));
var _TopMobileNav = _interopRequireDefault(require("./TopMobileNav"));
var _LanguageSelector = _interopRequireDefault(require("../LanguageSelector/LanguageSelector"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const MobileNav = props => {
  const {
    navOptions,
    rightLinks,
    disableLogin,
    disableLanguageRegion,
    disableSectorFlyOut,
    handleSectorFlyoutDeployed,
    sectorFlyoutLabel,
    languageSelectorData,
    languageSelectorDeployed,
    handleLanguageSelectorDeployed,
    saveLanguage = () => {},
    loginPage,
    isHidden,
    isAuthenticated,
    userProfile,
    logout,
    login,
    Link,
    authLabels,
    waffleMenu,
    featuredLink,
    closeAllDropDowns,
    disableCartFlyout,
    cartSettings,
    cartData,
    isCartFlyoutActive,
    setCartFlyoutActive,
    activeCurrency,
    setCurrency,
    currencies,
    isCurrencyLocked = false
  } = props;
  const {
    mouse,
    hamburgerIsOpen,
    searchFieldValue,
    handleSearchFieldChange,
    handleSearchSubmit,
    searchField,
    closeHamburger,
    isBottomBarActive,
    sectorFlyoutData
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [isOpen, setIsOpen] = (0, _react.useState)(null);
  const [languageSettings, setLanguageSettings] = (0, _react.useState)(languageSelectorData?.settings);
  const {
    isIos
  } = (0, _useNavigator.default)();
  const openDropDown = isOpen => {
    setIsOpen(isOpen);
  };
  const toggleDropDown = nextOpen => {
    if (isOpen === nextOpen) {
      setIsOpen(null);
    } else {
      setIsOpen(nextOpen);
    }
  };
  const closeAll = () => {
    closeHamburger();
    setTimeout(() => {
      setIsOpen(null);
    }, 300);
  };
  const flyoutPaddingClass = isIos && isBottomBarActive ? "ter-mobile-nav__flyout--extra-padding" : "ter-mobile-nav__flyout--regular-padding";
  const generateNavOptions = publicOnly => {
    return navOptions?.filter(option => {
      return publicOnly ? option.isPublicPage ? option.isPublicPage : option : option;
    })?.filter(option => {
      // filter out unusable options
      return option.type === "category" || option.type === "links" || option.type === "link" || option.type === "page" || option.type === "megaNav";
    })?.map((option, index) => {
      if (option.type === "category") {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenu.default, {
          key: option.contentfulId || index,
          isOpen: isOpen === option.contentfulId ? true : false,
          currentOpenMenu: isOpen,
          megaMenuContent: option,
          openDropDown: openDropDown,
          closeDropDown: closeAll,
          links: option.links,
          featuredLinks: option.featuredLinks,
          featuredLinksTitle: option.featuredLinksTitle && option.featuredLinksTitle,
          toggleDropDown: toggleDropDown,
          Link: Link,
          hamburgerIsOpen: hamburgerIsOpen
        });
      } else if (option.type === "links") {
        return /*#__PURE__*/_react.default.createElement(_MobileMenu.default, {
          text: option.text,
          links: option.links,
          key: option.contentfulId || index,
          isOpen: isOpen === option.contentfulId ? true : false,
          currentOpenMenu: isOpen,
          openDropDown: openDropDown,
          closeDropDown: closeAll,
          toggleDropDown: toggleDropDown,
          Link: Link,
          hamburgerIsOpen: hamburgerIsOpen,
          contentfulId: option.contentfulId
        });
      } else if (option.type === "megaNav") {
        const featuredLinks = option?.featuredSection?.promoLink ? [option?.featuredSection?.promoLink] : option?.featuredSection?.links;
        const featuredLinksTitle = option?.featuredSection?.promoLink ? option?.featuredSection?.promoTitle : option?.featuredSection?.title;
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenu.default, {
          key: option.contentfulId || index,
          isOpen: isOpen === option.contentfulId ? true : false,
          currentOpenMenu: isOpen,
          megaMenuContent: option,
          openDropDown: openDropDown,
          closeDropDown: closeAll,
          links: option.links,
          featuredLinks: featuredLinks,
          featuredLinksTitle: featuredLinksTitle,
          featuredPromoImage: option?.navCategoryPromo?.image || null,
          featuredPromoDescription: option?.navCategoryPromo?.description || null,
          featuredPromoPageLink: option?.navCategoryPromo?.pageLink || null,
          featuredPromoTitle: option?.navCategoryPromo?.title || null,
          toggleDropDown: toggleDropDown,
          Link: Link,
          hamburgerIsOpen: hamburgerIsOpen
        });
      } else if (option.type === "link" || option.type === "page") {
        return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
          tabIndex: mouse ? "" : "0",
          depth: 1,
          to: option.url,
          key: option.contentfulId || index,
          className: `ter-mobile-nav__link ${isOpen !== null ? "ter-mobile-nav__link--hidden" : ""} ${!hamburgerIsOpen ? "ter-top-mobile-nav__link-wrapper--hidden" : ""} ${mouse ? "" : "tabFocus"}`,
          onClick: closeAll,
          target: option.type === "link" ? "_blank" : "_self",
          Link: Link,
          isPublicPage: option.isPublicPage
        }, /*#__PURE__*/_react.default.createElement("p", null, option.text));
      }
    });
  };
  const confirmLanguage = region => {
    setLanguageSettings(region);
    saveLanguage(region);
  };
  const myDashboardLabel = authLabels?.myDashboard || "My Dashboard";
  const cartTitle = cartSettings?.cartTitle || "My Cart";
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-nav ${hamburgerIsOpen ? "ter-mobile-nav--is-open" : "ter-mobile-nav--is-hidden"} ${!disableSectorFlyOut && hamburgerIsOpen ? `ter-mobile-nav__flyout--active ${flyoutPaddingClass}` : ""}`,
    tabIndex: "-1"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-mobile-nav__container"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-mobile-nav__menus-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `${!hamburgerIsOpen ? "ter-mobile-nav__menus-container--fill--hidden" : ""}
            ${!disableLogin && !isAuthenticated ? "ter-mobile-nav__menus-container--no-fill" : "ter-mobile-nav__menus-container--fill"}`
  }), disableLogin || !disableLogin && isAuthenticated ? generateNavOptions() : generateNavOptions(true)), featuredLink && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    style: {
      visibility: isOpen === null ? "visible" : "hidden",
      transform: isOpen === null ? "translateX(0%)" : "translateX(-100%)",
      transition: "all 0.3s ease"
    },
    to: featuredLink?.url,
    depth: 1,
    tabIndex: mouse ? "" : "0",
    href: featuredLink?.url,
    onClick: () => closeAll,
    className: `ter-top-mobile-nav__link-wrapper ter-top-mobile-nav__link ${mouse ? "ter-navbar__nav-link" : "ter-navbar__nav-link tabFocus"}`,
    Link: Link,
    internalLink: featuredLink?.internalLink,
    ariaLabel: featuredLink?.external === true ? `Open ${featuredLink.text} in a new tab` : null,
    target: typeof featuredLink?.external === "boolean" ? featuredLink?.external ? "_blank" : "_self" : null
  }, featuredLink.text), /*#__PURE__*/_react.default.createElement(_TopMobileNav.default, {
    links: rightLinks,
    handleSearchFieldChange: handleSearchFieldChange,
    searchFieldValue: searchFieldValue,
    handleSearchSubmit: handleSearchSubmit,
    closeAll: closeAll,
    currentOpenMenu: isOpen,
    disableLogin: disableLogin,
    mouse: mouse,
    hamburgerIsOpen: hamburgerIsOpen,
    disableLanguageRegion: disableLanguageRegion,
    languageSelectorData: languageSelectorData,
    languageSelectorDeployed: languageSelectorDeployed,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed,
    loginPage: loginPage,
    login: login,
    isHidden: isHidden,
    Link: Link,
    isAuthenticated: isAuthenticated,
    userProfile: userProfile,
    logout: logout,
    authLabels: authLabels
  })), disableCartFlyout === false && /*#__PURE__*/_react.default.createElement(_MyCartMenu.default, {
    text: cartTitle,
    key: cartTitle,
    isOpen: isOpen === cartTitle,
    currentOpenMenu: isOpen,
    openDropDown: openDropDown,
    closeDropDown: closeAll,
    toggleDropDown: toggleDropDown,
    hamburgerIsOpen: hamburgerIsOpen,
    quantity: cartData?.totalLineItemQuantity,
    isCurrencyLocked: isCurrencyLocked,
    activeCurrency: activeCurrency,
    setCurrency: setCurrency,
    currencies: currencies,
    onOpenCart: () => setCartFlyoutActive(true),
    settings: cartSettings,
    Link: Link
  }), sectorFlyoutData?.authenticated && /*#__PURE__*/_react.default.createElement(_MobileDashboardMenu.default, {
    text: myDashboardLabel,
    links: waffleMenu?.links,
    cta: waffleMenu?.cta,
    key: myDashboardLabel,
    isOpen: isOpen === myDashboardLabel,
    currentOpenMenu: isOpen,
    openDropDown: openDropDown,
    closeDropDown: closeAll,
    toggleDropDown: toggleDropDown,
    Link: Link,
    hamburgerIsOpen: hamburgerIsOpen
  }), sectorFlyoutData?.login && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu ${isOpen !== null ? "ter-mobile-mega-menu--inactive" : ""}`,
    onClick: () => handleSectorFlyoutDeployed()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-mega-menu__name ter-mobile-mega-menu__name__flex ter-mobile-mega-menu__name__utility-link ter-mobile-mega-menu__name--open-parent tabFocus"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _user.default,
    width: "16",
    alt: "User",
    className: "ter-mobile-mega-menu__name__flex__icon"
  }), authLabels?.myAccount || "My Account", /*#__PURE__*/_react.default.createElement("img", {
    className: "ter-mobile-menu__caret ter-mobile-menu__caret--down",
    src: _downCaretDarkBlue.default,
    alt: "caret icon"
  }))), !disableSectorFlyOut && /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-nav__flyout-wrapper ${isOpen !== null ? "ter-mobile-nav__flyout-wrapper--inactive" : ""}`,
    onClick: () => handleSectorFlyoutDeployed()
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-nav__flyout-title"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-nav__flyout-title-text"
  }, sectorFlyoutLabel || "Explore Trimble"), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: "ter-mobile-nav__flyout-title-icon",
    size: "16px",
    type: "open-caret-right-dark-16px",
    color: "#005f9e"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-mobile-nav__flyout-logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _logoIcon.default,
    alt: "open flyout"
  }))), languageSelectorData && languageSelectorDeployed && /*#__PURE__*/_react.default.createElement(_LanguageSelector.default, {
    labels: languageSelectorData?.labels,
    settings: languageSelectorData?.settings,
    languages: languageSelectorData?.languages,
    regions: languageSelectorData?.regions,
    languageSelectorDeployed: languageSelectorDeployed,
    saveLanguage: saveLanguage,
    handleLanguageSelectorDeployed: handleLanguageSelectorDeployed
  }));
};
var _default = MobileNav;
exports.default = _default;